import { formatDistanceToNowStrict, formatDuration, isSameYear } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { getDurationInHours, getLocalTimezone } from 'lib/time'

export const formatPaymentTimestamp = (
  value: string,
  timeZone: string = getLocalTimezone()
): string => {
  const isCurrentYear = isSameYear(value, new Date())
  return formatInTimeZone(
    value,
    timeZone,
    isCurrentYear ? 'EEE MMM, dd, hh:mm a zz' : 'EEE MMM, dd, yyyy, hh:mm a zz'
  )
}

export const getShiftCalendarLines = (
  startsAt: string,
  endsAt: string,
  timeZone: string = getLocalTimezone()
) => {
  const day = formatInTimeZone(startsAt, timeZone, 'EEEE, MMMM d')
  const dayDistance = formatDistanceToNowStrict(startsAt, {
    addSuffix: true,
  })
  const startTime = formatInTimeZone(startsAt, timeZone, 'h:mm a')
  const endTime = formatInTimeZone(endsAt, timeZone, 'h:mm a z')
  const duration = formatDuration({
    hours: getDurationInHours(startsAt, endsAt),
  })

  return {
    day,
    dayDistance,
    timeRange: `${startTime} - ${endTime} (${duration})`,
  }
}
